import Vue from "vue";
import "amfe-flexible"; //750设计稿量多少写多少
import "normalize.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import lockr from 'lockr';
import Axios from "axios";
import './plugin/vant'  // 引入vant
import wx from "weixin-js-sdk";
import $ from 'jquery'
import myFilter from './filter'
Vue.prototype.axios = Axios;

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

// lockr.set("openId", 'oPF5uxEWdssp_bVjEgS2DP5-Z0zE');   //飞飞  废弃
// lockr.set("openId", 'oo05wvzjtnTRFecFjBLPY_ZMI5_M');   //飞飞  废弃
// lockr.set("openId", 'oPF5uxF7LZ8Oer1bFGnv7sSjeQgQ');   //飞飞  正式//
// lockr.set("mobile", '18839135695');
// lockr.get('mobile'),
window.Lockr = lockr;

import axiosApi from '@/api/axios.js'//封装axios文件
Vue.use(axiosApi);

//来关闭生产模式下给出的提示
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
